import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { FlashMessagesService } from 'flash-messages-angular';
import { Subject } from 'rxjs';
import { AdminService } from 'src/app/services/admin.service';
import { DatatablesHelper, TextHelper } from 'src/app/helpers';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-edit-agency',
  templateUrl: './edit-agency.component.html',
  styleUrls: ['./edit-agency.component.css']
})
export class EditAgencyComponent implements OnInit, OnDestroy {
  agencyID!: any;
  selectedAgency!: any;

  agencies: any[] = [];
  loaded = false;

  editMode: boolean = false;

  dtOptions: DataTables.Settings = {};

  // We use this trigger because fetching the list of users can take a while,
  // thus we ensure the data is fetched before rendering
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  constructor(
    private adminService: AdminService,
    private flashMessage: FlashMessagesService,
    private router: Router,
    private dialog: MatDialog,
    private clipboard: Clipboard
  ) {}

  ngOnInit(): void {
    this.initTable();
    this.loadAgencies();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  private initTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,

      // Declare the use of the extension in the dom parameter and give a class for the css (can't get the css to apply though so commented out)
      // dom: '<"table-buttons"lBfr>tip',
      dom: 'lBfrtip',
    };

    // Configure the buttons
    Object.assign(this.dtOptions, {
      buttons: [
        'excel'
      ]
    });
  }

  private async loadAgencies() {
    // Load all agencies
    const res: any = await this.adminService.getAgencies().toPromise();
    this.agencies = res.agencies;
    this.loadTable();
  }

  private loadTable() {
    if (this.loaded) {
      this.rerender();
    }
    else {
      // Calling the DT trigger to manually render the table
      this.dtTrigger.next();
      this.loaded = true;
    }
  }

  private async tryReloadAgencies() {
    // Reload table data
    await this.loadAgencies().catch(() => {});
  }

  // Edit mode
  editAgency(agency: any) {
    this.selectedAgency = agency;
    this.editMode = true;
  }

  viewUsers(agency: any) {
    this.router.navigate(['/admin/all-users'], { queryParams: { agencyid: agency._id } });
  }

  // Manual to rerender table
  private rerender(): void {
    DatatablesHelper.redrawTable(this.dtElement, this.dtTrigger);
  }

  // Submit edited agency
  async onSubmit() {
    const data: any = await this.adminService.updateAgency(this.selectedAgency).toPromise();

    await this.tryReloadAgencies();

    // Success
    if (data.success) {
      // Display success
      this.flashMessage.show('Successfully edited agency.', {
        cssClass: 'alert-success',
        timeout: 3000
      });
    }

    // DOM manipulation
    this.editMode = false;
  }

  async copyGeoJsonLink() {
    const link = await this.adminService.getGeoJsonLink('agencies').toPromise();

    await TextHelper.copy(link, this.clipboard);

    // Success
    this.flashMessage.show("Link copied to clipboard.", {
      cssClass: 'alert-success',
      timeout: 3000
    });
  }

  async copyGeoRssLink() {
    const link = await this.adminService.getGeoRssLink('agencies').toPromise();

    await TextHelper.copy(link, this.clipboard);

    // Success
    this.flashMessage.show("Link copied to clipboard.", {
      cssClass: 'alert-success',
      timeout: 3000
    });
  }
}
